// extracted by mini-css-extract-plugin
module.exports = {"tncIframe":"styles__tncIframe___2qMfM"};